import { DEFAULT_PAGINATION_LIMIT } from "../../../../../globalConstants";

export const STRINGS = {
  DEFAULT_PAGINATION_LIMIT: DEFAULT_PAGINATION_LIMIT,
  MODAL_MODE: {
    ADD: "A",
    EDIT: "E",
    DELETE: "D",
    SUCCESS: "S",
    FAILURE: "F",
    DEFAULT: "",
  },
  MODAL_SIZE: {
    X_SMALL: "xs",
    SMALL: "sm",
    MEDIUM: "md",
    LARGE: "lg",
  },
  CONTACT_TYPE: {
    LITIGATION: "L",
    RELATIVE: "R",
  },
  ERROR_MAPPING: {
    NAME_REQD: "Name is a required field",
    EMAIL_OR_PHONE_REQD: "Both Email and Phone cannot be blank.",
    EMAIL_INVLD: "Email format is invalid",
    PHONE_INVLD: "Phone format is invalid",
  },
};
